// components/SubscriptionSavings.js
import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import SavingsIcon from '@mui/icons-material/Savings';

const SubscriptionSavings = ({ 
  oneTimePrice, 
  subscriptionPrice, 
  variant = 'default', 
  showIcon = true,
  color = 'success'
}) => {
  // Рассчитываем экономию
  const savings = oneTimePrice - subscriptionPrice;
  const savingsPercent = oneTimePrice > 0 ? Math.round((savings / oneTimePrice) * 100) : 0;

  // Если экономии нет, не показываем компонент
  if (savings <= 0) return null;

  // Разные варианты отображения
  const variants = {
    compact: {
      fontSize: '0.75rem',
      fontWeight: 500,
      spacing: 0.5,
      iconSize: 'small'
    },
    default: {
      fontSize: '0.875rem',
      fontWeight: 600,
      spacing: 1,
      iconSize: 'small'
    },
    large: {
      fontSize: '1rem',
      fontWeight: 700,
      spacing: 1.5,
      iconSize: 'medium'
    }
  };

  const style = variants[variant] || variants.default;

  // Для чипа
  if (variant === 'chip') {
    return (
      <Chip
        icon={showIcon ? <SavingsIcon /> : undefined}
        label={`Save €${savings.toFixed(2)} (${savingsPercent}%)`}
        color={color}
        size="small"
        variant="outlined"
        sx={{ 
          fontWeight: 600,
          '& .MuiChip-icon': {
            fontSize: 16
          }
        }}
      />
    );
  }

  // Для инлайн текста
  if (variant === 'inline') {
    return (
      <Typography 
        variant="caption" 
        sx={{ 
          color: color === 'success' ? 'success.main' : `${color}.main`,
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5
        }}
      >
        {showIcon && <SavingsIcon sx={{ fontSize: 14 }} />}
        Save €{savings.toFixed(2)} ({savingsPercent}%)
      </Typography>
    );
  }

  // Обычный вариант
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: style.spacing,
        color: color === 'success' ? 'success.main' : `${color}.main`
      }}
    >
      {showIcon && (
        <TrendingDownIcon 
          sx={{ 
            fontSize: style.iconSize === 'small' ? 16 : 20,
            color: 'inherit'
          }} 
        />
      )}
      <Typography 
        variant="caption" 
        sx={{ 
          fontSize: style.fontSize,
          fontWeight: style.fontWeight,
          color: 'inherit'
        }}
      >
        Save €{savings.toFixed(2)} ({savingsPercent}% off)
      </Typography>
    </Box>
  );
};

export default SubscriptionSavings; 